import { fetchJson } from './fetchJson'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function put(url: string, data: any): Promise<any> {
  return fetchJson({ method: 'PUT', url, data })
}
